import { cloneDeep, sumBy } from 'lodash';

import { getOrderItemPrice } from '@/components/modals/SubmitOrder/constants';
import { OrderItemWrapper, State } from '@/components/modals/SubmitOrder/types';
import { ProposalVm } from '@/types';

export enum systemGroup {
  'TS Basic Services' = 1,
}

// TODO: Delete this once this is completely removed
export const TS_BASIC_SERVICES_BUNDLE_PRICE = 1500;

export const isDesignService = (service: OrderItemWrapper) =>
  service.priceBookEntry.name === 'Design Services';

export const getBundleTotal = (
  orderItems: OrderItemWrapper[],
  state: State,
  proposal: ProposalVm | null,
) => {
  return sumBy(orderItems, service => getOrderItemPrice(state, service, proposal));
};

export const bundleItemsBySystemGroup = (
  orderItems: OrderItemWrapper[],
  targetSystemGroup: number,
) => {
  const orderItemsClone = cloneDeep(orderItems);
  const bundleServices: OrderItemWrapper[] = [];

  for (let i = orderItemsClone.length - 1; i >= 0; i--) {
    if (orderItemsClone[i].priceBookEntry.product.systemGroup === targetSystemGroup) {
      bundleServices.push(...orderItemsClone.splice(i, 1));
    }
  }

  return { modifiedArray: orderItemsClone, bundleServices: bundleServices.reverse() };
};
